interface SearchBoxProps {
  value: string;
  onChange: (value: string) => void;
  aiIdPrefix?: string;
}

export function SearchBox({ value, onChange, aiIdPrefix = 'studio-search-field' }: SearchBoxProps) {
  return (
    <label className="block" data-ai-id={aiIdPrefix}>
      <span className="block" data-ai-id={`${aiIdPrefix}-input-wrapper`}>
        <input
          type="search"
          value={value}
          onChange={(event) => onChange(event.target.value)}
          aria-label="연습실 검색"
          placeholder="이름이나 위치로 검색"
          className="h-12 w-full rounded-2xl border border-slate-200 bg-slate-50 px-4 text-base text-slate-950 outline-none transition focus:border-emerald-500 focus:bg-white focus:ring-4 focus:ring-emerald-100"
          data-ai-id={`${aiIdPrefix}-input`}
        />
      </span>
    </label>
  );
}
